export default __webpack_public_path__ + "static/BioRhymeExpanded-Regular-kern-latin-d08b8578edcce4c0c73677e59b609d03.woff2";